import React, { useState } from 'react'
import './Eventenquiry.css';
import Subscribe from '../components/Subscribe';
import Footer from '../components/Footer';
import Contact from './Contact';

const Eventenquiry = ({ onContactClick }) => {
  const [showContact, setShowContact] = useState(false)

  const handleContactClick = () => {
    if (typeof onContactClick === 'function') {
      onContactClick()
    }
    setShowContact(true)
  }

  return (
    <>
    <div className="event-enquiry-container">
      <div className="event-enquiry-content">
        <h1 className="event-enquiry-title">Let's Create Something Together</h1>
        <p className="event-enquiry-subtitle">Tell us what you're planning — we'll help shape the experience.</p>
        
        <h2 className="coming-soon-text">COMING SOON</h2>
        
        <button className="contact-us-btn" onClick={handleContactClick}>
          Contact Us
        </button>
      </div>
    </div>
    {showContact && <Contact onClose={() => setShowContact(false)} />}
    {/* <Subscribe />
    <Footer /> */}
    </>
  )
}

export default Eventenquiry
